<div class="form-group box-accordion-mobile" *ngIf="checkViewMode('edit')">
  <div class="row">
    <div class="col-md-12">
        <label for="" *ngIf="getOptionByKey(attribute,'hideTitle')=='false'">
            {{attribute.key}}
            <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info" [popover]="getOptionByKey(attribute,'tooltip')"
            placement="right"
            container="body"
            triggers="mouseenter:mouseleave">
              <i class="fa fa-question-circle"></i>
            </div>
          </label>
      <div *ngFor="let item of attribute.attributes;let index = index">
          <label>{{item.key}}</label>
        <app-dynamic *ngFor="let itemAttributes of item.attributes" [attribute]="itemAttributes"></app-dynamic>
        {{ngLoaded()}}
      </div>
    </div>
  </div>
</div>

<div class="form-group box-accordion-mobile d-print-block" *ngIf="checkViewMode('view')">
    {{hasContent(attribute.attributes)}}
    <div class="row accordionView">
      <div class="col-md-12">
          <label for="" *ngIf="getOptionByKey(attribute,'hideTitle')=='false'">
              {{attribute.key}}
              <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info" [popover]="getOptionByKey(attribute,'tooltip')"
              placement="right"
              container="body"
              triggers="mouseenter:mouseleave">
                <i class="fa fa-question-circle"></i>
              </div>
            </label>
        <div *ngFor="let item of attribute.attributes;let index = index">
          <app-dynamic *ngFor="let itemAttributes of item.attributes" [attribute]="itemAttributes"></app-dynamic>
          {{ngLoaded()}}
        </div>
      </div>
    </div>
  </div>

<div class="form-group box-accordion-desktop" *ngIf="checkViewMode('edit')">
  <div class="row">
    <div class="col-md-12">
      <label for="" *ngIf="getOptionByKey(attribute,'hideTitle')=='false'">
        {{attribute.key}}
        <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info" [popover]="getOptionByKey(attribute,'tooltip')"
        placement="right"
        container="body"
        triggers="mouseenter:mouseleave">
          <i class="fa fa-question-circle"></i>
        </div>
      </label>
      <div class="m-accordion m-accordion--default m-accordion--solid m-accordion--section  m-accordion--toggle-arrow"
        id="m_accordion_7" role="tablist">
        <div class="m-accordion__item" *ngFor="let item of attribute.attributes;let index = index">
          <div class="m-accordion__item-head" role="tab" [id]="'m_accordion_7_'+uniqueId+index+'_head'" data-toggle="collapse"
            aria-expanded="false">
            <span class="m-accordion__item-icon">
              <i class="fa fa-file-text"></i>
            </span>
            <span class="m-accordion__item-title">
              {{item.key}}
              <div *ngIf="getOptionByKey(item,'title')" class="popover-info" popover="Pisos, Enchimentos e Impermeabilização"
                [popoverTitle]="" popoverPlacement="right" [popoverOnHover]="true" [popoverCloseOnClickOutside]="false"
                [popoverCloseOnMouseOutside]="false" [popoverDisabled]="false" [popoverAnimation]="true">
                <i class="fa fa-question-circle"></i>
              </div>
            </span>
            <span class="m-accordion__item-mode"></span>
          </div>
          <div class="m-accordion__item-body collapse" [id]="'m_accordion_7_'+uniqueId+index+'_body'" role="tabpanel"
            data-parent="#m_accordion_7">
            <div class="m-accordion__item-content">
              <app-dynamic *ngFor="let itemAttributes of item.attributes" [attribute]="itemAttributes"></app-dynamic>
            </div>
          </div>
          {{ngLoaded()}}
        </div>
      </div>
    </div>
  </div>
</div>

<div class="form-group box-accordion-desktop d-print-none" *ngIf="checkViewMode('view')">
    {{hasContent(attribute.attributes)}}
    <div class="row accordionView">
      <div class="col-md-12">
        <label for="" *ngIf="getOptionByKey(attribute,'hideTitle')=='false'">
          {{attribute.key}}
          <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info" [popover]="getOptionByKey(attribute,'tooltip')"
          placement="right"
          container="body"
          triggers="mouseenter:mouseleave">
            <i class="fa fa-question-circle"></i>
          </div>
        </label>
        <div class="m-accordion m-accordion--default m-accordion--solid m-accordion--section  m-accordion--toggle-arrow"
          id="m_accordion_8" role="tablist">
          <div class="m-accordion__item" *ngFor="let item of attribute.attributes;let index = index">
            <div [hidden]="hasItemContent(item)" [class]="'m-accordion__item-head accordionItemView_'+item.key" role="tab" [id]="'m_accordion_8_'+uniqueId+index+'_head'" data-toggle="collapse"
              aria-expanded="false">
              <span class="m-accordion__item-icon">
                <i class="fa fa-file-text"></i>
              </span>
              <span class="m-accordion__item-title">
                {{item.key}}
                <div *ngIf="getOptionByKey(item,'title')" class="popover-info" popover="Pisos, Enchimentos e Impermeabilização"
                  [popoverTitle]="" popoverPlacement="right" [popoverOnHover]="true" [popoverCloseOnClickOutside]="false"
                  [popoverCloseOnMouseOutside]="false" [popoverDisabled]="false" [popoverAnimation]="true">
                  <i class="fa fa-question-circle"></i>
                </div>
              </span>
              <span class="m-accordion__item-mode"></span>
            </div>
            <div [hidden]="hasItemContent(item)" [class]="'m-accordion__item-body collapse accordionItemView_'+item.key" [id]="'m_accordion_8_'+uniqueId+index+'_body'" role="tabpanel"
              data-parent="#m_accordion_8">
              <div class="m-accordion__item-content">
                <app-dynamic *ngFor="let itemAttributes of item.attributes" [attribute]="itemAttributes"></app-dynamic>
              </div>
            </div>
            {{ngLoaded()}}
          </div>
        </div>
      </div>
    </div>
  </div>
